import type { VideoSource } from 'lightgallery/plugins/video/types';
import type { LightGalleryVideoSource } from './media-viewer-light-gallery.types';

export function createVideoSource(src: string, fileType?: string): VideoSource {
  const videoSource: LightGalleryVideoSource = {
    source: [
      {
        src,
        type: fileType ?? '',
      },
    ],
    attributes: {
      preload: false,
      controls: true,
    },
  };

  // The interface for `VideoSource` doesn't match its intended use.
  // For now just trick the compiler that the data types are correct.
  // https://github.com/sachinchoolur/lightGallery/issues/1518
  return videoSource as unknown as VideoSource;
}
